module.exports = __webpack_public_path__ + "static/media/codekitchenlogo.80718bab.png";